import { useQuery } from "@tanstack/react-query";
import { getFrameAnalysticApiRequest } from "../../services/frame/get.frame.analystic.api";

export const useGetFrameAnalysticApi = ({
  accountId,
  startDate,
  endDate,
}: any) => {
  const { data, isLoading } = useQuery({
    queryKey: ["frame-analystic", startDate, endDate, accountId],
    queryFn: () =>
      getFrameAnalysticApiRequest({ accountId, startDate, endDate }),
    enabled: !!accountId && !!startDate && !!endDate,
  });
  return {
    frameAnalystic: data,
    isLoading,
  };
};
